export default function ScreenLoader({
  label = "Carregando",
  options = {
    fullScreen: true,
    color: "primary-blue-500",
  },
}: {
  label?: string;
  options?: {
    fullScreen: boolean;
    color: string;
  };
}) {
  return (
    <div className={`flex items-center text-base justify-center ${options?.fullScreen && "h-full w-full absolute"} text-${options?.color} font-bold z-10`}>
      <span
        className="loader spinner-1 mr-2"
        style={{
          borderTopColor: options.color,
        }}
      ></span>{" "}
      {label}
    </div>
  );
}
